import React, { useCallback, useMemo } from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@material-ui/core'
import { useForm } from 'react-hook-form'
import {
  useRemoveAiScheduledDigest,
  useRemoveAiScheduledPrompt
} from '../../../../../api/denaliAssistant'
import { decipherError } from '../../../../../utils/decipherError'
import SydModalActions from '../../../../../components/commonDesign/SydModal/SydModalActions'
import SydButton from '../../../../../components/commonDesign/Button'

const useSubmitter = (form, scheduleId, isDigest, onComplete) => {
  const { handleSubmit, clearErrors } = form
  const { mutateAsync: removeDigest, isLoading: removingDigest } = useRemoveAiScheduledDigest()
  const { mutateAsync: removePrompt, isLoading: removingPrompt } = useRemoveAiScheduledPrompt()
  const isLoading = useMemo(() => {
    return removingPrompt || removingDigest
  }, [removingPrompt, removingDigest])

  const onSubmit = useCallback(async () => {
    const command = {
      scheduleId
    }

    try {
      form?.clearErrors?.()
      const result = isDigest ? await removeDigest(command) : removePrompt(command)
      onComplete(result)
    } catch (err) {
      form.setError('root', {
        type: 'custom',
        message: decipherError(err) || `Something unexpected happened while deleting the scheduled ${isDigest ? 'digest' : 'prompt'}.`
      })
    }
  }, [form, scheduleId, onComplete, removeDigest, removePrompt, isDigest])

  const submitter = useCallback(async (e) => {
    const onValid = async (form) => {
      await onSubmit(form)
    }
    const onInvalid = (errors) => {
      console.error(errors)
    }
    clearErrors()
    const handler = handleSubmit(onValid, onInvalid)
    await handler(e)
  }, [handleSubmit, clearErrors, onSubmit])

  return {
    submitter,
    processing: isLoading
  }
}

function DeleteScheduleForm ({ schedule, onCancel, onComplete }) {
  const form = useForm({
    mode: 'onChange',
    defaultValues: {}
  })
  const { submitter, processing } = useSubmitter(form, schedule?.scheduleId, schedule.isDigest, onComplete)

  return (
    <div>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          Are you sure you want to delete this {schedule?.isDigest ? 'digest' : 'scheduled prompt'}?
        </Grid>

        {/* Actions */}
        <Grid item xs={12}>
          <SydModalActions>
            {/* {error && <div className='__error'>{error}</div>} */}
            <SydButton
              disabled={processing}
              variant='ghost'
              size='md'
              onClick={onCancel}
            >
              Cancel
            </SydButton>
            <SydButton
              processing={processing}
              variant='primary'
              priority='warning'
              icon='delete'
              size='md'
              onClick={submitter}
            >
              Delete {schedule?.isDigest ? 'Digest' : 'Scheduled Prompt'}
            </SydButton>
          </SydModalActions>
        </Grid>
      </Grid>
    </div>
  )
}

DeleteScheduleForm.propTypes = {
  schedule: PropTypes.shape({
    scheduleId: PropTypes.string.isRequired,
    isDigest: PropTypes.bool.isRequired
  }).isRequired,
  onComplete: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
}

export default DeleteScheduleForm
